var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tco-choose-product-container"},[_c('TcoChooseProductRules'),_c('TcoProductListGrid',{staticClass:"mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }